import { takeEvery, takeLatest, put, call, all } from 'redux-saga/effects';
import { toast, ToastContainer } from "react-toastify";
// import { fetchMenuDataSuccess, fetchMenuDataFailure } from './usersSlice'; // Import your actions
import menuList from "../sample-data/menu.json"
import {
  addUserSuccess, deleteUserSuccess, fetchMenuDataSuccess, generateOTPSuccess, loginSuccess, editUserSuccess,
  loginOTPsuccess, fetchUserList, addCategorySuccess, editCategorySuccess, deleteCategorySuccess, addItemSuccess,
  fetchMenuItemsSuccess, fetchMenuItemsError, removeItemSuccess, updateOrderStatusFailure, updateOrderStatusSuccess,
  editMenuItem, fetchLiveOrderSuccess, fetchLiveOrderFailure, fetchOrderHistoryFailure, fetchCancelledOrderFailure,
  fetchCancelledOrderSuccess, addTableNumberSuccess, addTableNumberFailure, fetchTablesSuccess, fetchTablesFailure,
  editMenuItemSuccess, deleteTableSuccess, deleteTableFailure, editTableSuccess, editTableFailure, getRestaurantDetailSuccess,
  getRestaurantDetailFailure, updateRestaurantProfileSuccess, updateRestaurantProfileFailure, getRestaurantDetailRequest,
  fetchTaxSuccess, fetchTaxFailure, updateTaxSuccess, updateTaxFailure, updateTableStatusSuccess, updateTableStatusFailure,
  fetchBillSuccess, fetchBillsSuccess, fetchBillItemSuccess, clearCart, loadCartFromBill, fetchReservationSuccess, fetchReservationFailure,
  editReservationSuccess, fetchDashboardSuccess, changePasswordSuccess,
  fetchServiceRequestSuccess,
  updateServiceRequestSuccess,placeOrderSuccess,
  closeGlobalPopup,
  fetchBannerSuccess,
  addBannerSuccess,
  deleteBannerSuccess,
  updateBannerStatusSuccess,
  updateBannerSuccess

}
  from './action';
import {
  ADD_USER, SAVE_USER_FAILURE, DELETE_USER, UPDATE_USER, API_FETCH_MENU, GENERATE_LOGIN_OTP, SEND_LOGIN_OTP, GET_LOGGED_USER, SEND_LOGIN, SEND_LOGOUT, LOGIN_ERROR, RESET_PASSWORD, FETCH_USERS,
  FETCH_USERS_SUCCESS, FETCH_USERS_ERROR, UPDATE_STATUS_API, SEND_LOGIN_SUCCESS, FETCH_CATEGORIES_SUCCESS, FETCH_CATEGORIES, ADD_CATEGORY, SAVE_CATEGORY_FAILURE, FETCH_CATEGORIES_ERROR, UPDATE_CATEGORY,
  DELETE_CATEGORY, ADD_MENU_ITEM, SAVE_MENU_ITEM_FAILURE, API_FETCH_MENU_ITEM, REMOVE_ITEM_MENU, UPDATE_MENU_ITEM,
  FETCH_LIVE_ORDERS, UPDATE_ORDER_STATUS, FETCH_ORDER_HISTORY, FETCH_CANCEL_ORDER, ADD_TABLE_NUMBER, FETCH_TABLES, DELETE_TABLE, EDIT_TABLE, FETCH_RESTAURANT_DETAIL_REQUEST,
  UPDATE_RESTAURANT_PROFILE_REQUEST, FETCH_TAX_REQUEST, UPDATE_TAX_REQUEST, FETCH_TABLES_WITH_OTP, UPDATE_TABLE_STATUS_REQUEST,
  FETCH_LIVE_ORDERS_BY_TABLEOTP, FETCH_ORDER_HISTORY_BY_TABLEOTP, PLACE_ORDER_FOR_TABLE, CREATE_RESERVATION_REQUEST, GET_RESERVATIONS_REQUEST,
  FETCH_BILL_REQUEST, SAVE_BILL_REQUEST, SAVE_BILL_SUCCESS, SAVE_BILL_FAILURE, FETCH_BILLS, FETCH_BILL_ITEM, CREATE_RESERVATION_SUCCESS, SAVE_RESERVATION_FAILURE,
  UPDATE_RESERVATION_REQUEST, FETCH_DASHBOARD, CHANGE_PASSWORD,FETCH_GALLERY_IMAGE,
  FETCH_SERVICE_REQUEST, UPDATE_SERVICE_REQUEST,VERIFY_CONTACT_NUMBER, RESET_PASSWORD_SUCCESS,
  API_FETCH_BANNER, ADD_BANNER,SAVE_BANNER_FAILURE,DELETE_BANNER,UPDATE_BANNER_STATUS,UPDATE_BANNER,
  FETCH_ADDON_GROUPS, SET_ADDON_GROUPS, SAVE_ADDON_GROUP, SAVE_ADDON_GROUP_SUCCESS, SAVE_ADDON_GROUP_FAILURE, DELETE_ADDON_GROUP, DELETE_ADDON_GROUP_SUCCESS, DELETE_OPERATION_FAILURE, FETCH_CATEGORY_ADDON_MAPPINGS, UPDATE_BANNER_STATUS_FAILURE,
  SET_CATEGORY_ADDON_MAPPINGS,
  SAVE_CATEGORY_ADDON_MAPPINGS, CLEAR_CATEGORY_ADDON_MAPPINGS,FETCH_MENU_ITEM_ADDON_MAPPINGS,
  SET_MENU_ITEM_ADDON_MAPPINGS,SAVE_MENU_ITEM_ADDON_OVERRIDE,
} from './constant';
import {
  fetchLogin, Login, addUser, getUsers, updateUser, deleteUser, getLoggedInUser, logOut, addCategory, getCategories, updateCategory, getFoodItems,
  deleteCategory, addFoodItem, deleteFoodItem, updateFoodItem, getMenuList, updateMenuItemAvailabilityStatus, getLiveOrderList, updateOrderStatusAPI, getOrderHistoryList,
  getOrderCancelledList, getSessionValues, addTableNumberAPI, fetchTablesAPI, deleteTableAPI, editTableAPI, fetchRestaurantDetail, updateRestaurantProfileAPI,
  getTaxAPI, updateTaxAPI, updateTableStatusAPI, getLiveOrderByTableOtp, getOrderHistoryListByTableOtp, placeOrderAPI, getBill, saveBillApi,
  fetchAPI, getBills, getBillItems, addReservationAPI, fetchReservationAPI, updateReservationAPI, fetchDashboardAPI, changePasswordAPI,
  fetchServiceRequestAPI, updateServiceRequestStatusAPI, getEmployeeDetailByContactNumber, verifyContactNumberAPI, verifyOtpForgotPasswordAPI,
  forgetPasswordAPI, fetchBannersAPI, addBannerAPI, deleteBannerAPI ,updateBannerStatusAPI, updateBannerAPI,fetchGalleryImagesAPI,
  fetchAddonGroupsApi, saveAddonGroupApi, deleteAddonGroupApi, getCategoryAddonMappingsAPI, mapCategoryAddonsAPI, getMenuItemAddonMappingsAPI,
  setMenuItemAddonOverrideAPI,
} from './api';
import { userList } from '../sample-data/admindata';
import { saveContentTranslations } from '../i18n/contentTranslationApi';

function* saveTranslationsSafely(entityType, entityId, translations) {
  if (!entityId || !translations) return;
  try {
    yield call(saveContentTranslations, entityType, entityId, translations);
  } catch (error) {
    console.error(`Could not save ${entityType} translations:`, error);
    toast.warning("The item was saved, but its translations could not be saved. You can add them again while editing.");
  }
}


// Simulate API call for password reset
function* resetPasswordSaga(action) {
  try {
    // Simulate API call: yield call(api.resetPassword, action.payload)
    console.log('RESET_PASSWORD saga called', action.payload);
    // You can dispatch a success action here if needed
    // yield put({ type: RESET_PASSWORD_SUCCESS });
    const url ='ForgetPassword'
    const passwordReset = yield forgetPasswordAPI(url, action.payload);
    console.log('resetPasswordSaga', passwordReset);

    if(passwordReset !== false){      
        window.location.reload();
        toast.success("Password reset successfully")  
        yield put({ type: RESET_PASSWORD_SUCCESS, payload: passwordReset });
    }
 
   // yield put(loginSuccess(user));
    //yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: LOGIN_ERROR, payload: error.message || 'Login failed' });
    // Optionally handle error
    // yield put({ type: RESET_PASSWORD_ERROR, payload: error.message });
  }
}

// const fetchMenuDataSuccess = () => {}
const fetchMenuDataFailure = () => { }

function* fetchAddUser(d) {
  console.log('API_FETCH_ADD_USER called, so fetchAddUser', d, d?.payload);
  try {
    // todo: API implementation pending
    // const response = yield call(fetch, 'https://api.example.com/users');
    // const data = yield call([response, 'json']);
    const url = `AddUser`;
    const user = yield addUser(url, d?.payload);
    console.log('user', user);
    yield put(addUserSuccess({ ...user, id: Date.now() }));
    yield put({ type: FETCH_USERS });
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: SAVE_USER_FAILURE, payload: error?.message || "Could not save the user." });
    toast.error(error?.message || "Could not save the user. Please try again.");
  }
}

export const fetchUsersSaga = function* () {
  console.log('FETCH_USERS called');
  try {
    // Simulate API call to fetch users
    // const response = yield call(fetch, 'https://api.example.com/users');
    // const data = yield call([response, 'json']);
    const url = `GetUsers`;
    const data = yield getUsers(url);
    console.log('user', data);
    //const data = yield call([response, 'json']);

    //const data = userList; // Replace with actual data fetching logic
    // yield put(addUserSuccess(data));
    yield put({ type: FETCH_USERS_SUCCESS, payload: data });
  } catch (error) {
    console.error('Error fetching users:', error);
    yield put({ type: FETCH_USERS_ERROR, payload: [] }); // Dispatch empty array on error
  }
  console.log('FETCH_USERS_ERROR completed');
  // You can dispatch a success action here if needed
  // yield put({ type: FETCH_USERS_SUCCESS, payload: data });
}

function* fetchDeleteUser(d) {
  console.log('API_FETCH_DELETE_USER called', d, d?.payload);
  try {
    // todo: API implementation pending
    // const response = yield call(fetch, 'https://api.example.com/users');
    // const data = yield call([response, 'json']);
    const url = `DeleteUser/${d?.payload}`;
    const response = yield deleteUser(url);
    console.log('user', response);
    yield put(deleteUserSuccess(d.payload));
    // ✅ Then refresh the user list
    yield put({ type: 'FETCH_USERS' }); // trigger your "fetch users" saga
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: DELETE_OPERATION_FAILURE, payload: error?.message || "Could not delete the user." });
  }
}

function* fetchUpdateUser(d) {
  try {
    const url = `UpdateUser`;
    const data = yield updateUser(url, d?.payload);
    console.log("Backend updated user data:", data);

    yield put(editUserSuccess(data));
    yield put({ type: FETCH_USERS });
    yield put(closeGlobalPopup());
  } catch (error) {
    console.error("Error updating user:", error);
    yield put({ type: SAVE_USER_FAILURE, payload: error?.message || "Could not save the user." });
    toast.error(error?.message || "Could not save the user. Please try again.");
  }
}

function* fetchAddCategory(d) {
  console.log('API_FETCH_ADD_USER called, so fetchAddCategory', d, d?.payload);
  try {
    const url = `AddCategory`;
    const { translations, ...categoryPayload } = d?.payload || {};
    const category = yield addCategory(url, categoryPayload);
    yield* saveTranslationsSafely("category", category?.categoryId || categoryPayload.categoryId, translations);
    console.log('AddCategory', category);
    yield put(addCategorySuccess({ ...category, id: Date.now() }));
    yield put({ type: FETCH_CATEGORIES });
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: SAVE_CATEGORY_FAILURE, payload: error?.message || "Could not save the category." });
    toast.error(error?.message || "Could not save the category. Please try again.");
  }
}

export const fetchCategoriesSaga = function* () {
  console.log('FETCH_CATEGORIES called');
  try {
    // Simulate API call to fetch users
    // const response = yield call(fetch, 'https://api.example.com/users');
    // const data = yield call([response, 'json']);
    const url = `GetCategories`;
    const data = yield getCategories(url);
    console.log('FETCH_CATEGORIES', data);
    //const data = yield call([response, 'json']);

    //const data = userList; // Replace with actual data fetching logic
    //  yield put(addCategorySuccess(data));
    yield put({ type: FETCH_CATEGORIES_SUCCESS, payload: data });
  } catch (error) {
    console.error('Error fetching Categories:', error);
    yield put({ type: FETCH_CATEGORIES_ERROR, payload: [] }); // Dispatch empty array on error
  }
  console.log('FETCH_USERS_ERROR completed');
  // You can dispatch a success action here if needed
  // yield put({ type: FETCH_USERS_SUCCESS, payload: data });
}

function* fetchUpdateCategory(d) {
  try {
    const url = `UpdateCategory`;
    const { translations, ...categoryPayload } = d?.payload || {};
    const data = yield updateCategory(url, categoryPayload);
    yield* saveTranslationsSafely("category", categoryPayload.categoryId || data?.categoryId, translations);
    console.log("Backend Updated Category data:", data);

    yield put(editCategorySuccess(data));
    yield put({ type: FETCH_CATEGORIES });
    yield put(closeGlobalPopup());
  } catch (error) {
    console.error("Error updating Category:", error);
    yield put({ type: SAVE_CATEGORY_FAILURE, payload: error?.message || "Could not save the category." });
    toast.error(error?.message || "Could not save the category. Please try again.");
  }
}

function* fetchDeleteCategory(d) {
  console.log('API_FETCH_DELETE_CATEGORIES called', d, d?.payload);
  try {
    const url = `DeleteCategory/${d?.payload}`;
    const response = yield deleteCategory(url);
    console.log('delete Category response...', response);
    yield put(deleteCategorySuccess(d.payload));
    // ✅ Then refresh the Category list
    yield put({ type: 'FETCH_CATEGORIES' }); // trigger your "fetch users" saga
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: DELETE_OPERATION_FAILURE, payload: error?.message || "Could not delete the category." });
  }
}

function* getRestaurantDetail(action) {
  try {
    const url = `GetRestaurantDetail`;
    const data = yield call(fetchRestaurantDetail, url);
    console.log("getRestaurantDetailSaga", data)
    yield put(getRestaurantDetailSuccess(data));
  } catch (error) {
    yield put(getRestaurantDetailFailure(error.message));
  }
}

function* updateRestaurantProfile(action) {
  try {
    let url;
    console.log("action.payload.contactNumber", action.payload.contactNumber)
    console.log("action.payload.mail", action.payload.mail)
    if (action.payload.contactNumber || action.payload.mail) {
      url = "UpdateClient";
    }
    else {
      url = "UpdateRestaurantProfile";
    }
    console.log("updateRestaurantProfile url", url)
    // const url = `UpdateRestaurantProfile`;
    const data = yield call(updateRestaurantProfileAPI, url, action.payload);
    console.log("updateRestaurantProfileSaga", data)
    yield put(updateRestaurantProfileSuccess(data));

    // ✅ trigger a fresh fetch of restaurant details 
    yield put(getRestaurantDetailRequest());
    yield put(closeGlobalPopup());
  }
  catch (error) {
    yield put(updateRestaurantProfileFailure(error.message));
  }
}

function* deleteTable(action) {
  try {
    const url = 'DeleteTable';
    yield call(deleteTableAPI, url, action.payload);
    yield put(deleteTableSuccess(action.payload));
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put(deleteTableFailure(error.message));
  }
}

function* editTable(action) {
  try {
    const url = 'UpdateTable';
    const updated = yield call(editTableAPI, url, action.payload);
    yield put(editTableSuccess(updated));
    yield put({ type: FETCH_TABLES });
    yield put(closeGlobalPopup());
  }
  catch (error) {
    yield put(editTableFailure(error.message));
  }
}

const fetchMenuItemsSaga = function* (d) {
  console.log('API_FETCH_MENU_iTEM called', d);
  try {
    const url = `GetMenuItemByCategoryId`;
    const foodItems = yield getFoodItems(url, d?.payload);
    console.log('API_FETCH_MENU_iTEM ', foodItems);

    yield put(fetchMenuItemsSuccess({ ...foodItems }));
    // yield put({ type: API_FETCH_MENU_iTEM_SUCCESS, payload: data });
  } catch (error) {
    console.error('Error fetching Categories:', error);
    yield put(fetchMenuItemsError([]));
  }
}

// function* fetchAddMenuItem(d) {
//   console.log('ADD_MENU_ITEM called, so fetchAddMenuItem', d, d?.payload);
//   try {
//     const url = `AddMenuItem`;
//     const foodItem = yield addFoodItem(url, d?.payload);
//     console.log('AddMenu', foodItem);
//     yield put(addItemSuccess({ ...foodItem, id: Date.now() }));
//     yield put(closeGlobalPopup());
//   } catch (error) {
//     // yield put(fetchMenuDataFailure(error));
//   }
// }

function* fetchAddMenuItem(d) {
  console.log('ADD_MENU_ITEM called, so fetchAddMenuItem', d, d?.payload);
  try {
    const url = `AddMenuItem`;
    
    // 1. itemOverrides alag karein taaki AddMenuItem API ko clean DTO mile
    const { itemOverrides, translations, ...menuItemPayload } = d?.payload || {};

    // 2. Food Item pehle database mein save karein
    const foodItem = yield call(addFoodItem, url, menuItemPayload);
    console.log('AddMenu response:', foodItem);

    // 3. Saved MenuId nikaalein (Backend se ya payload se)
    const savedMenuId = foodItem?.menuId || menuItemPayload?.menuId;
    yield* saveTranslationsSafely("menu", savedMenuId, translations);

    // 4. ⭐ FIX: setMenuItemAddonOverrideAPI function ko call karein (String nahi!)
    if (itemOverrides && itemOverrides.length > 0 && savedMenuId) {
      for (const override of itemOverrides) {
        try {
          const overrideUrl = "SetMenuItemAddonOverride";
          yield call(setMenuItemAddonOverrideAPI, overrideUrl, {
            menuId: savedMenuId,
            addonGroupId: override.addonGroupId,
            isExcluded: override.isExcluded,
          });
          console.log(`✅ Addon override saved for group: ${override.addonGroupId}`);
        } catch (err) {
          console.error(`❌ Failed to save addon override:`, err);
        }
      }
    }

    // 5. Redux state update karein
    yield put(addItemSuccess({ ...foodItem, id: Date.now() }));
    yield put(closeGlobalPopup());
    
    // 6. Menu data refresh karein taaki naya item naye add-ons ke sath sync ho jaye
    yield put({ type: 'API_FETCH_MENU' });

  } catch (error) {
    console.error('Error in fetchAddMenuItem saga:', error);
    const message = error?.message || "Food item could not be added. Please check the details and try again.";
    yield put({ type: SAVE_MENU_ITEM_FAILURE, payload: message });
    toast.error(message);
  }
}

function* fetchDeleteMenuItem(d) {
  console.log('REMOVE_ITEM_MENU called', d, d?.payload);
  try {
    const url = `DeleteMenuItem/${d?.payload.menuId}`;
    const response = yield deleteFoodItem(url);
    console.log('delete menu item', response);
    yield put(removeItemSuccess(d.payload.menuId));
    // ✅ Then refresh the user list
    yield put({ type: 'API_FETCH_MENU_ITEM', payload: d?.payload.categoryId }); // trigger your "fetch users" saga
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: DELETE_OPERATION_FAILURE, payload: error?.message || "Could not delete the food item." });
  }
}

function* fetchUpdateMenuItem(d) {
  try {
    const url = `UpdateMenuItem`;
    const { itemOverrides = [], translations, ...menuItemPayload } = d?.payload || {};
    const data = yield updateFoodItem(url, menuItemPayload);
    yield* saveTranslationsSafely("menu", menuItemPayload.menuId || data?.menuId, translations);
    console.log("Backend Updated Menu Item data:", data);

    for (const override of itemOverrides) {
      yield call(setMenuItemAddonOverrideAPI, "SetMenuItemAddonOverride", {
        menuId: menuItemPayload.menuId,
        addonGroupId: override.addonGroupId,
        isExcluded: override.isExcluded,
      });
    }

    const updatedItem = Array.isArray(data)
      ? data.find((item) => item?.menuId === menuItemPayload.menuId)
      : data;
    yield put(editMenuItemSuccess(updatedItem || {
      ...menuItemPayload,
      menuSizeOptions: menuItemPayload.MenuSizeOptions || []
    }));
    yield put({ type: API_FETCH_MENU_ITEM, payload: menuItemPayload.categoryId });
    yield put(closeGlobalPopup());
  } catch (error) {
    console.error("Error updating Menu Item:", error);
    const message = error?.message || "Food item could not be updated. Please check the details and try again.";
    yield put({ type: SAVE_MENU_ITEM_FAILURE, payload: message });
    toast.error(message);
  }
}

function* fetchMenuData(d) {
  console.log('API_FETCH_MENU called, so fetchMenuData', d);
  try {
    const url = `DisplayMenu`;
    const data = yield getMenuList(url);
    //  const data = menuList;
    console.log("DisplayMenu", data)
    // const data = 'menuList';
    yield put(fetchMenuDataSuccess(data));
  } catch (error) {
    yield put(fetchMenuDataFailure(error));
  }
}

function* fetchLiveOrderData(d) {
  console.log('FETCH_LIVE_ORDER called, so fetchLiveOrderData', d);
  try {
    const url = `GetLiveKot`;
    const data = yield getLiveOrderList(url);
    //  const url = `get`;
    //   const data = getSessionValues(url);
    console.log("live order:", data)

    yield put({ type: 'FETCH_LIVE_ORDER_SUCCESS', payload: data });
    //yield put(fetchLiveOrderSuccess(data));
  } catch (error) {
    yield put(fetchLiveOrderFailure(error));
  }
} //fetchLiveOrderDataByTableOtp

function* fetchLiveOrderDataByTableOtp(d) {
  console.log('FETCH_LIVE_ORDER_TABLEOTP called, so fetchLiveOrderData', d);
  try {
    const url = `GetLiveKOTByTableOtp`;
    const data = yield getLiveOrderByTableOtp(url, d);
    //  const url = `get`;
    //   const data = getSessionValues(url);
    console.log("live order by table otp:", data)

    yield put({ type: 'FETCH_LIVE_ORDER_SUCCESS', payload: data });
    //yield put(fetchLiveOrderSuccess(data));
  } catch (error) {
    yield put(fetchLiveOrderFailure(error));
  }
}

function* fetchOrderHistoryData(d) {
  console.log('FETCH_ORDER_HISTORY called, so fetchLiveOrderData', d);
  try {
    const url = `GetKotHistory`;
    const data = yield getOrderHistoryList(url);
    //  const data = menuList;
    console.log("history order:", data)
    // const data = 'menuList';
    yield put({ type: 'FETCH_ORDER_HISTORY_SUCCESS', payload: data });
    //yield put(fetchLiveOrderSuccess(data));
  } catch (error) {
    yield put(fetchOrderHistoryFailure(error));
  }
}

function* fetchOrderHistoryDataByTableOtp(d) {
  console.log('FETCH_ORDER_HISTORY_BY_TABLEOTP called, so fetchLiveOrderData', d);
  try {
    const url = `GetKotHistoryByTableOtp`;
    const data = yield getOrderHistoryListByTableOtp(url, d);
    //  const data = menuList;
    console.log("history order By table otp:", data)
    // const data = 'menuList';
    yield put({ type: 'FETCH_ORDER_HISTORY_SUCCESS', payload: data });
    //yield put(fetchLiveOrderSuccess(data));
  } catch (error) {
    yield put(fetchOrderHistoryFailure(error));
  }
}

function* fetchCancelledOrderData(d) {
  console.log('FETCH_CANCEL_ORDER called, so fetchCancelledOrderData', d);
  try {
    const url = `GetCancelledKot`;
    const data = yield getOrderCancelledList(url);
    //  const data = menuList;
    console.log("cancelled order:", data)
    // const data = 'menuList';
    yield put({ type: 'FETCH_CANCEL_ORDER_SUCCESS', payload: data });
    //yield put(fetchLiveOrderSuccess(data));
  } catch (error) {
    yield put(fetchCancelledOrderFailure(error));
  }
}

function* updateOrderStatus(action) {
  try {
    const url = `UpdateOrderStatus`; // adjust to your backend endpoint
    console.log("updateOrderStatus", action)
    console.log("updateOrderStatus", action.payload)
    const result = yield call(updateOrderStatusAPI, url, action.payload);

    yield put(updateOrderStatusSuccess(result));
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put(updateOrderStatusFailure(error));
  }
}

function* fetchTax(action) {
  try {
    const url = `GetTax`;
    const data = yield call(getTaxAPI, url);
    console.log("fetchTax", data)
    yield put(fetchTaxSuccess(data));
  } catch (error) {
    yield put(fetchTaxFailure(error.message));
  }
}

function* updateTax(action) {
  try {
    const url = `UpdateTaxSetting`;
    const data = yield call(updateTaxAPI, url, action.payload);
    yield put(updateTaxSuccess(data)); // refresh tax details after update 
    yield put({ type: FETCH_TAX_REQUEST, payload: action.payload.restaurantOrBranchId });
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put(updateTaxFailure(error.message));
  }
}

function* updateTableStatus(action) {
  try {
    const url = `UpdateTableStatus`;
    const data = yield call(updateTableStatusAPI, url, action.payload);
    yield put(updateTableStatusSuccess(data)); // refresh tax details after update 
    yield put({ type: FETCH_TABLES_WITH_OTP, payload: data });
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put(updateTableStatusFailure(error.message));
  }
}


function* fetchTables() {
  try {
    const url = `GetTables`;
    const result = yield call(fetchTablesAPI, url);
    console.log("fetchTables result", result)
    yield put(fetchTablesSuccess(result));
    // yield put({ type: 'FETCH_TABLES_SUCCESS', payload: result});
  } catch (error) {
    yield put(fetchTablesFailure(error.message));
  }
}

function* fetchTablesWitOtp() {
  try {
    const url = `GetTablesWithOtp`;
    const result = yield call(fetchTablesAPI, url);
    console.log("fetchTables result", result)
    yield put(fetchTablesSuccess(result));
    // yield put({ type: 'FETCH_TABLES_SUCCESS', payload: result});
  } catch (error) {
    yield put(fetchTablesFailure(error.message));
  }
}

function* addTableNumber(action) {
  try {
    const { tableNumber, capacity, startTableNumber, endTableNumber } = action.payload;

    console.log("addTableNumber", action)
    let result;
    if (tableNumber) {
      // Single table case
      console.log("Single table case", action)
      console.log("Single table case", tableNumber)
      const url = `CreateTable`;
      result = yield call(addTableNumberAPI, url, tableNumber, capacity);
    } else if (startTableNumber && endTableNumber) {
      // Bulk case
      const url = `CreateRangeTable`;
      result = yield call(addTableNumberAPI, url, startTableNumber, capacity, endTableNumber);
    } else {
      throw new Error("Invalid table input");
    }
    console.log("result", result)
    yield put(addTableNumberSuccess(result));
    yield put({ type: FETCH_TABLES });
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put(addTableNumberFailure(error.message));
  }
}

function* saveBillSaga(action) {
  try {
    const { bill, billItems, billingType, tableOtp, payments, actionReason } = action.payload;
    console.log("action.payload",action.payload)
    console.log("action.payload",action.payload)
    const url = 'SaveBill';
    const response = yield call(saveBillApi, url, bill, billItems, billingType, tableOtp, payments, actionReason);
    console.log("response",response)
    yield put({ type: SAVE_BILL_SUCCESS, payload: response }); //clearCart
    yield put({ type: 'CLEAN_BILL_ITEM'});
   // yield put(clearCart());
    toast.success(`Bill saved successfully`);
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: SAVE_BILL_FAILURE, payload: error.message });
  }
}

export function* fetchBanners(){
  try {
    const url = `GetRestaurantBanners`;
    const result = yield call(fetchBannersAPI, url);
    console.log("GetRestaurantBanner result", result)
    yield put(fetchBannerSuccess(result));
  } catch (error) {

  }
}

function* addBanner(action) {
  try {
    const url = 'CreateRestaurantBanner';
    const { translations, ...bannerPayload } = action.payload || {};
    const response = yield call(addBannerAPI, url, bannerPayload);
    yield* saveTranslationsSafely("banner", response?.bannerId || bannerPayload.bannerId, translations);
    yield put(addBannerSuccess({ ...bannerPayload, ...response, bannerImage: bannerPayload.bannerImage }));
    toast.success(`Banner added successfully`);
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: SAVE_BANNER_FAILURE, payload: error?.message || "Could not save the banner." });
    toast.error(error?.message || "Could not save the banner. Please try again.");
  }
}

function* deleteBanner(d){
   console.log('deleteBanner called', d, d?.payload);
  try {
    const url = `DeleteRestaurantBanner/${d?.payload}`;
    //const response = yield deleteBannerAPI(url);
    const response = yield call(deleteBannerAPI, url);
    console.log('delete banner response...', response);
    yield put(deleteBannerSuccess(d.payload));
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: DELETE_OPERATION_FAILURE, payload: error?.message || "Could not delete the banner." });
  }
}

function* updateBannerStatus(action){
  try {
    const url = `UpdateBannerStatus`;
    const updatedData = yield call(updateBannerStatusAPI,url, action.payload);
    yield put(updateBannerStatusSuccess(updatedData));
  } catch (error) {
    yield put({
      type: UPDATE_BANNER_STATUS_FAILURE,
      payload: {
        bannerId: action.payload.bannerId,
        previousDisplayOnMenu: action.payload.previousDisplayOnMenu,
        error: error?.message || "Could not update banner status.",
      },
    });
    toast.error(error?.message || "Could not update banner status. Please try again.");
  }
}

function* updateBanner(action){
  try {
    const url = `UpdateBanner`;
    const { translations, ...bannerPayload } = action.payload || {};
    const updatedData = yield call(updateBannerAPI,url, bannerPayload);
    yield* saveTranslationsSafely("banner", bannerPayload.bannerId || updatedData?.bannerId, translations);
    const { originalBannerImage, ...submittedBanner } = bannerPayload;
    yield put(updateBannerSuccess({
      bannerId: updatedData.bannerId || submittedBanner.bannerId,
      bannerName: updatedData.bannerName ?? submittedBanner.bannerName,
      bannerImage: submittedBanner.bannerImage,
      updatedAt: updatedData.updatedAt,
    }));
    toast.success(`Banner updated successfully`);
    yield put(closeGlobalPopup());
  } catch (error) {
    console.error("Saga Status Flip Error Tracker:", error);
    yield put({ type: SAVE_BANNER_FAILURE, payload: error?.message || "Could not save the banner." });
    toast.error(error?.message || "Could not save the banner. Please try again.");
  }
}

function* fetchDashboard(d) {
  try {
    const url = `GetDashboard`;
    const result = yield call(fetchDashboardAPI, url, d);
    console.log("GetDashboard result", result)
    yield put(fetchDashboardSuccess(result));
    // yield put({ type: 'FETCH_TABLES_SUCCESS', payload: result});
  } catch (error) {

  }
}

function* fetchServiceRequests() {
  try {
    const url = `GetServiceRequests`;
    const result = yield call(fetchServiceRequestAPI, url);
    console.log("GetServiceRequests result", result)
    yield put(fetchServiceRequestSuccess(result));
    // yield put({ type: 'FETCH_TABLES_SUCCESS', payload: result});
  } catch (error) {

  }
}

function* updateServiceRequestStatus(action) {
  try {
    const url = action.payload.length > 0 ? `CleanServiceRequest` : `UpdateServiceRequest`;
    console.log("updateServiceRequestStatus url", url)
    const data = yield call(updateServiceRequestStatusAPI, url, action.payload);
    yield put(updateServiceRequestSuccess(data)); // refresh tax details after update 
    // yield put({ type: FETCH_TABLES_WITH_OTP, payload: data });
    yield put(closeGlobalPopup());
  }
  catch (error) {
    //yield put(updateTableStatusFailure(error.message)); 
  }
}

function* addReservation(action) {
  try {
    const url = 'CreateReservation';
    const response = yield call(addReservationAPI, url, action.payload);
    yield put({ type: CREATE_RESERVATION_SUCCESS, payload: response }); //clearCart
    yield put({ type: GET_RESERVATIONS_REQUEST });
    toast.success(`Reservation added successfully`);
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: SAVE_RESERVATION_FAILURE, payload: error?.message || "Could not save the reservation." });
    toast.error(error?.message || "Could not save the reservation. Please try again.");
  }
}

export function* fetchReservation() {
  try {
    const url = `GetReservations`;
    const result = yield call(fetchReservationAPI, url);
    console.log("GetReservations result", result)
    yield put(fetchReservationSuccess(result));
    // yield put({ type: 'FETCH_TABLES_SUCCESS', payload: result});
  } catch (error) {
    yield put(fetchReservationFailure(error.message));
  }
}

function* updateReservation(d) {
  console.log("UPDATE_RESERVATION_REQUEST called:", d);

  try {
    const url = "UpdateReservation";
    const payload = Object.values(d);
    const result = yield updateReservationAPI(url, payload[1]);

    yield put(editReservationSuccess(result));
    yield put({ type: GET_RESERVATIONS_REQUEST });
    toast.success(`Reservation updated successfully`);
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: SAVE_RESERVATION_FAILURE, payload: error?.message || "Could not save the reservation." });
    toast.error(error?.message || "Could not save the reservation. Please try again.");
  }
}


export function* updateMenuItemStatus(d) {
  console.log("UPDATE_STATUS_API called:", d);

  try {
    const url = d?.payload?.scheduleUpdate ? "SaveAvailabilitySchedule" : "UpdateMenuItemAvailability";
    const result = yield updateMenuItemAvailabilityStatus(url, d?.payload?.scheduleUpdate ? d.payload.data : d?.payload);

    yield put(fetchMenuDataSuccess(result));
    yield put(closeGlobalPopup());
  } catch (error) {
    toast.error(d?.payload?.scheduleUpdate
      ? "Could not save the schedule. Check the timezone and time slots, then try again."
      : "Could not update item availability. Please try again.");
  }
}

function* changePasswordRequest(d) {
  console.log("UPDATE_STATUS_API called:", d);

  try {
    const url = "ChangePassword";
    const result = yield changePasswordAPI(url, d?.payload);
    toast.success('Password change successfully');
    yield put(changePasswordSuccess(result));
    yield put(closeGlobalPopup());
  } catch (error) {

  }
}

// function* placeOrderForTable(g) {
//   console.log('PLACE_ORDER_FOR_TABLE called, so place order', g);

//   try {

//     const { data, tableName } = g.payload;
//     const url = `StaffOrderForTable`;
//     const result = yield placeOrderAPI(url, data, tableName, true)
//     console.log('place order', result);

   
//     toast.success('Order placed successfully');
//     yield put(closeGlobalPopup());
//    // window.location.reload();
//    // yield put(placeOrderSuccess({ redirectTo: "MENU"}));
//   } catch (error) {
//     console.log("error..........", error.message)
//     // if (error?.message === '"Invalid table OTP"' || error === 'Error: "Invalid table OTP"') { toast.error('Invalid table OTP'); } else { toast.error('Error while placing order'); }
//     // toast.error(error?.message + " redirecting to table page.");
//     // yield put(fetchMenuDataFailure(error));
//   }
// }


function* placeOrderForTable(g) {
  console.log('PLACE_ORDER_FOR_TABLE called, so place order', g);

  try {
    const { data, tableName } = g.payload;
    const url = `StaffOrderForTable`;
    const result = yield placeOrderAPI(url, data, tableName, true);
    console.log('place order', result);

    toast.success('Order placed successfully');
    yield put(closeGlobalPopup());

    // 🌟 FIXED: Is code block se order place hote hi sirf is dynamic table ka cart empty ho jayega
    yield put({ type: "CLEAR_CART_FOR_TABLE", payload: { tableName } });
    
  } catch (error) {
    console.log("error..........", error.message);
  }
}

function* generateOTP(g) {
  console.log('GENERATE_LOGIN_OTP called, so generateOTP', g);
  const url = `GetEmployeeDetailByContactNumber`;
  const result = yield getEmployeeDetailByContactNumber(url, g.payload)
  try {
    yield put(generateOTPSuccess(result));
    yield put(closeGlobalPopup());
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
} 

function* VerifyContactNumber(g) {
  console.log('VERIFY_CONTACT_NUMBER called, so generateOTP', g);
  const url = `VerifyContactNumber`;
  const result = yield verifyContactNumberAPI(url, g.payload)
  console.log("result",result)
  try {
    //yield put(generateOTPSuccess(result));
    //yield put(closeGlobalPopup());
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

function* login(g) {
  console.log('SEND_LOGIN called, so generateOTP', g);
  const { username, password } = g.payload;
  const userId = g.payload;
  const dto = { phoneNumber: '0000000000', userName: username, password: password };
  //encodeURIComponent(username);
  const encodedPassword = encodeURIComponent(password);
  // const url = `RestaurantLogin/${encodedUsername}/${encodedPassword}`;
  //console.log("userId",userId)
  console.log("username", username)
  console.log("password", password)
  //const url = `RestaurantLogin`;
  const url = `HashingLogin`;
  try {
    if (username !== undefined && password !== undefined) {
      const result = yield fetchLogin(url, dto);
      if (result === 0) {
        // ✅ Single restaurant case
        console.log('Single restaurant case', result);
        yield put({ type: SEND_LOGIN_SUCCESS, payload: JSON.parse(localStorage.getItem("admin_token_info")) });
      } else if (Array.isArray(result)) {
        // ✅ Multiple restaurants case
        console.log('Multiple restaurant case', result);
        yield put({ type: SEND_LOGIN_SUCCESS, payload: { restros: result } });
      }
    }
    else {
      const url = `GetUserInfoInJWTToken/${userId.selectedUserId}`;
      // yield fetchAPI(url);
      yield Login(url);
      yield put({ type: SEND_LOGIN_SUCCESS, payload: JSON.parse(localStorage.getItem("admin_token_info")) });
    }

    // else
    // const   result = yield fetchLogin(url1);
    //yield put(loginSuccess({...data}));



    // yield put({ type: SEND_LOGIN_SUCCESS,payload: { user: data } });
    yield put(closeGlobalPopup());
  } catch (error) {
    yield put({ type: LOGIN_ERROR, payload: error.message || 'Login failed' });
  }
}

function* logout(g) {
  console.log('SEND_LOGOUT called, so generateOTP', g);
  try {
    const url = `logout`;
    yield logOut(url);
    console.log('logOut');
    //  yield put({ type:SEND_LOGOUT,payload: { restros: data } });
    yield put(closeGlobalPopup());
  } catch (error) {
    // yield put({ type: LOGIN_ERROR, payload: error.message || 'Logout failed' });
  }
}

function* getUser(g) {
  console.log('GET_LOGGED_USER called, so generateOTP', g);
  // const user = {name: '', jwt: '__JWT__'}
  const user = yield getLoggedInUser('')
  console.log('user', user);
  try {
    yield put(loginSuccess(user));
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

function* fatchBill(g) {
  console.log('FETCH_BILL_REQUEST called, so re-order', g);

  try {
    const url = `GetBill`;
    console.log("fatchBill",g.payload)
    const result = yield getBill(url, g.payload.billId ?? g.payload, g.payload.isViewBill)
    console.log('GetBill', result);
    yield put(fetchBillSuccess(result));
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

function* fatchBills(g) {
  console.log('FETCH_BILLS called', g);

  try {
    const url = `GetBills`;
    const result = yield getBills(url)
    console.log('GetBills', result);
    yield put(fetchBillsSuccess(result));
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

function* fatchBillItems(g) {
  console.log('FETCH_BILL_ITEM called', g);

  try {
    const url = `GetBillItems`;
    const result = yield getBillItems(url, g.payload)
    console.log('GetBills', result);
    yield put(fetchBillItemSuccess(result));
    yield put(loadCartFromBill(result));
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

function* loginOTP(g) {
  console.log('SEND_LOGIN_OTP called, so generateOTP', g);
  // const user = {name: '', jwt: '__JWT__'}
  // const user = yield fetchLoginOTP('')
  // console.log('user', user);
  try {
    const url = `VerifyOtpForgotPassword`;
    const result = yield verifyOtpForgotPasswordAPI(url, g.payload)
    
    console.log("VerifyOtpForgotPassword",result)
    yield put(loginOTPsuccess(result));
    //yield put(closeGlobalPopup());
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

// Worker Saga: Fetch Addons
function* fetchAddonGroupsSaga() {
  try {
    // const restaurantId = yield select((state) => state.user?.restaurantId || state.admin?.restaurantId);
    // if (!restaurantId) return;
    const url = `GetAddonGroups`;
    const data = yield fetchAddonGroupsApi(url);
    yield put({ type: SET_ADDON_GROUPS, payload: data });
  } catch (error) {
    console.error("fetchAddonGroupsSaga error:", error);
    yield put({ type: SET_ADDON_GROUPS, payload: [] });
  }
}

// Worker Saga: Save Addon
export function* saveAddonGroupSaga(action) {
  try {
    const url = `SaveAddonGroup`;
    const { translations, ...addonPayload } = action.payload || {};
    const savedAddonGroup = yield call(saveAddonGroupApi, url, addonPayload);
    yield* saveTranslationsSafely("addon-group", savedAddonGroup?.addonGroupId || addonPayload.addonGroupId, translations);
    yield put({ type: SAVE_ADDON_GROUP_SUCCESS, payload: savedAddonGroup });
    yield put({ type: FETCH_ADDON_GROUPS }); // Refresh list
    yield put(closeGlobalPopup());
  } catch (error) {
    console.error("saveAddonGroupSaga error:", error);
    yield put({ type: SAVE_ADDON_GROUP_FAILURE, payload: error?.message || "Could not save the add-on group." });
    toast.error(error?.message || "Could not save the add-on group. Please try again.");
  }
}

// Worker Saga: Delete Addon
export function* deleteAddonGroupSaga(action) {
  try {
    const url = `DeleteAddonGroup`;
    yield call(deleteAddonGroupApi, url, action.payload);
    yield put({ type: DELETE_ADDON_GROUP_SUCCESS, payload: action.payload });
    yield put({ type: FETCH_ADDON_GROUPS }); // Refresh list
    yield put(closeGlobalPopup());
  } catch (error) {
    console.error("deleteAddonGroupSaga error:", error);
    yield put({ type: DELETE_OPERATION_FAILURE, payload: error?.message || "Could not delete the add-on group." });
  }
}

function* fetchCategoryAddonMappingsSaga(action) {
  try {
    const url = `GetCategoryAddons`;
    const data = yield call(getCategoryAddonMappingsAPI, url,action.payload);
    const groupIds = Array.isArray(data) ? data.map(item => item.addonGroupId || item) : [];
    yield put({
      type: SET_CATEGORY_ADDON_MAPPINGS,
      payload: { categoryId: action.payload, groupIds }
    });
  } catch (error) {
    console.error("fetchCategoryAddonMappingsSaga error:", error);
    yield put({
      type: SET_CATEGORY_ADDON_MAPPINGS,
      payload: { categoryId: action.payload, groupIds: [] }
    });
  }
}

// Worker Saga: Save Mappings
function* saveCategoryAddonMappingsSaga(action) {
  try {
    const url = `MapCategoryAddons`;
    yield call(
      mapCategoryAddonsAPI, url,action.payload);
    // Close modal on success
    yield put(closeGlobalPopup());
  } catch (error) {
    console.error("saveCategoryAddonMappingsSaga error:", error);
  }
}

function* fetchGalleryImages(action) {
  try {
    const url = 'GetGalleryImages';
    console.log("fetchGalleryImages",action.payload)
    const result = yield call(fetchGalleryImagesAPI, url, action.payload || '');
    yield put({ type: 'FETCH_GALLERY_IMAGE_SUCCESS', payload: result });
  } catch (error) {
    toast.error("Failed to upload gallery image");
  }
}

// Worker Saga: Fetch Item Addon Mappings
function* fetchMenuItemAddonMappingsSaga(action) {
  try {
    const url = "MenuItem";
    const data = yield call(getMenuItemAddonMappingsAPI, url, action.payload);
    yield put({
      type: SET_MENU_ITEM_ADDON_MAPPINGS,
      payload: { menuId: action.payload, mappings: Array.isArray(data) ? data : [] }
    });
  } catch (error) {
    console.error("fetchMenuItemAddonMappingsSaga error:", error);
    yield put({
      type: SET_MENU_ITEM_ADDON_MAPPINGS,
      payload: { menuId: action.payload, mappings: [] }
    });
  }
}

// Worker Saga: Save Item Addon Override
function* saveMenuItemAddonOverrideSaga(action) {
  try {
    const url = "SetMenuItemAddonOverride";
    yield call(setMenuItemAddonOverrideAPI, url, action.payload);
  } catch (error) {
    console.error("saveMenuItemAddonOverrideSaga error:", error);
  }
}



export function* watchAddGalleryImage() {
  yield takeEvery('FETCH_GALLERY_IMAGE', fetchGalleryImages);
}

function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePasswordRequest);
}

function* watchFetchBill() {
  yield takeEvery(FETCH_BILL_REQUEST, fatchBill);
}

function* watchFetchBills() {
  yield takeEvery(FETCH_BILLS, fatchBills);
}

function* watchFetchBillItem() {
  yield takeEvery(FETCH_BILL_ITEM, fatchBillItems);
}

function* watchFetchUsersSaga() {
  yield takeEvery(FETCH_USERS, fetchUsersSaga);
}

// User Alteration
function* watchUpdateUser() {
  yield takeEvery(UPDATE_USER, fetchUpdateUser);
}

function* watchDeleteUser() {
  yield takeEvery(DELETE_USER, fetchDeleteUser);
}

function* watchAddUser() {
  yield takeEvery(ADD_USER, fetchAddUser);
}

function* watchAddCategory() {
  yield takeEvery(ADD_CATEGORY, fetchAddCategory);
}

function* watchUpdateCategory() {
  yield takeEvery(UPDATE_CATEGORY, fetchUpdateCategory);
}

function* watchUpdateMenuItem() {
  yield takeEvery(UPDATE_MENU_ITEM, fetchUpdateMenuItem);
}

function* watchFetchCategoriesSaga() {
  yield takeEvery(FETCH_CATEGORIES, fetchCategoriesSaga);
}

function* watchFetchFoodItemsSaga() {
  yield takeEvery(API_FETCH_MENU_ITEM, fetchMenuItemsSaga);
}

function* watchDeleteCategory() {
  yield takeEvery(DELETE_CATEGORY, fetchDeleteCategory);
}

function* watchAddMenuItem() {
  yield takeEvery(ADD_MENU_ITEM, fetchAddMenuItem);
}

function* watchFetchMenu() {
  yield takeEvery(API_FETCH_MENU, fetchMenuData);
}

function* watchFetchLiveOrder() {
  yield takeEvery(FETCH_LIVE_ORDERS, fetchLiveOrderData);
}

function* watchFetchLiveOrderByTableOtp() {
  yield takeEvery(FETCH_LIVE_ORDERS_BY_TABLEOTP, fetchLiveOrderDataByTableOtp);
}

function* watchDeleteMenuItem() {
  yield takeEvery(REMOVE_ITEM_MENU, fetchDeleteMenuItem);
}

function* watchUpdateMenuItemStatus() {
  yield takeEvery(UPDATE_STATUS_API, updateMenuItemStatus);
}

function* watchGenerateLoginOTP() {
  yield takeEvery(GENERATE_LOGIN_OTP, generateOTP);
}

function* watchVerifyContactNumber() {
  yield takeEvery(VERIFY_CONTACT_NUMBER, VerifyContactNumber);
}

function* watchLoginSubmit() {
  yield takeEvery(SEND_LOGIN, login);
}

function* watchLogoutSubmit() {
  yield takeEvery(SEND_LOGOUT, logout);
}

function* watchLoginOTPSubmit() {
  yield takeEvery(SEND_LOGIN_OTP, loginOTP);
}

function* watchGetUser() {
  console.log('watchGetUser called');
  yield takeEvery(GET_LOGGED_USER, getUser);
}

function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPasswordSaga);
}

function* watchUpdateOrderStatus() {
  yield takeEvery(UPDATE_ORDER_STATUS, updateOrderStatus);
}

function* watchOrderHistoryData() {
  yield takeEvery(FETCH_ORDER_HISTORY, fetchOrderHistoryData);
}

function* watchOrderHistoryDataByTableOtp() {
  yield takeEvery(FETCH_ORDER_HISTORY_BY_TABLEOTP, fetchOrderHistoryDataByTableOtp);
}

function* watchCancelledOrder() {
  yield takeEvery(FETCH_CANCEL_ORDER, fetchCancelledOrderData);
}

function* watchAddTableNumber() {
  yield takeEvery(ADD_TABLE_NUMBER, addTableNumber);
}

function* watchFetchTables() {
  yield takeEvery(FETCH_TABLES, fetchTables);
}

function* watchFetchTablesWitOtp() {
  yield takeEvery(FETCH_TABLES_WITH_OTP, fetchTablesWitOtp);
}

function* watchDeleteTable() {
  yield takeEvery(DELETE_TABLE, deleteTable); // keep your other sagas here too 
}

function* watchEditTable() {
  yield takeEvery(EDIT_TABLE, editTable); // keep your other sagas here too 
}

function* watchGetRestaurantDetail() {
  yield takeEvery(FETCH_RESTAURANT_DETAIL_REQUEST, getRestaurantDetail);
}

function* watchUpdateRestaurantProfile() {
  yield takeEvery(UPDATE_RESTAURANT_PROFILE_REQUEST, updateRestaurantProfile);
}

function* watchFetchTax() {
  yield takeEvery(FETCH_TAX_REQUEST, fetchTax);
}

function* watchUpdateTax() {
  yield takeEvery(UPDATE_TAX_REQUEST, updateTax);
}

function* watchUpdateTableStatus() {
  yield takeEvery(UPDATE_TABLE_STATUS_REQUEST, updateTableStatus);
}

function* watchPlaceOrder() {
  yield takeEvery(PLACE_ORDER_FOR_TABLE, placeOrderForTable);
}

function* watchSaveBill() {
  yield takeEvery(SAVE_BILL_REQUEST, saveBillSaga);
}

function* watchAddReservation() {
  yield takeEvery(CREATE_RESERVATION_REQUEST, addReservation);
}

function* watchFetchReservation() {
  yield takeEvery(GET_RESERVATIONS_REQUEST, fetchReservation);
}

function* watchUpdateReservation() {
  yield takeEvery(UPDATE_RESERVATION_REQUEST, updateReservation);
}

function* watchfetchDashboard() {
  yield takeEvery(FETCH_DASHBOARD, fetchDashboard);
}

function* watchfetchServiceRequest() {
  yield takeEvery(FETCH_SERVICE_REQUEST, fetchServiceRequests);
}

function* watchUpdateServiceRequest() {
  yield takeEvery(UPDATE_SERVICE_REQUEST, updateServiceRequestStatus);
}

function* watchfetchBannersRequest(){
  yield takeEvery(API_FETCH_BANNER, fetchBanners);
}

function* watchaddBannerRequest(){
  yield takeEvery(ADD_BANNER, addBanner);
}

function* watchdeleteBannerRequest(){
  yield takeEvery(DELETE_BANNER, deleteBanner);
}

export function* watchupdateBannerStatus() {
  yield takeEvery(UPDATE_BANNER_STATUS, updateBannerStatus);
}  

export function* watchupdateBanner() {
  yield takeEvery(UPDATE_BANNER, updateBanner);
}

export function* watchfetchAddonGroupsSaga() {
  yield takeLatest(FETCH_ADDON_GROUPS, fetchAddonGroupsSaga);
}

export function* watchsaveAddonGroupSaga() {
  yield takeEvery(SAVE_ADDON_GROUP, saveAddonGroupSaga);
}

export function* watchdeleteAddonGroupSaga() {
  yield takeEvery(DELETE_ADDON_GROUP, deleteAddonGroupSaga);
}

export function* categoryAddonWatcherSaga() {
  yield takeLatest(FETCH_CATEGORY_ADDON_MAPPINGS, fetchCategoryAddonMappingsSaga);
}

export function* categorySaveCategoryAddonMappingsSaga() {
  yield takeEvery(SAVE_CATEGORY_ADDON_MAPPINGS, saveCategoryAddonMappingsSaga);
}

export function* watchMenuItemAddonMappingsSaga() {
  yield takeLatest(FETCH_MENU_ITEM_ADDON_MAPPINGS, fetchMenuItemAddonMappingsSaga);
}

export function* watchSaveMenuItemAddonOverrideSaga() {;
  yield takeEvery(SAVE_MENU_ITEM_ADDON_OVERRIDE, saveMenuItemAddonOverrideSaga);
}

function* userSaga() {
  yield all([
    watchMenuItemAddonMappingsSaga(),
    watchSaveMenuItemAddonOverrideSaga(),
    categoryAddonWatcherSaga(),
    categorySaveCategoryAddonMappingsSaga(),
    watchfetchAddonGroupsSaga(),
    watchsaveAddonGroupSaga() ,
    watchdeleteAddonGroupSaga(),
    watchAddGalleryImage(),
    watchfetchBannersRequest(),
    watchaddBannerRequest(),
    watchupdateBannerStatus(),
    watchupdateBanner(),
    watchdeleteBannerRequest(),
    watchVerifyContactNumber(),
    watchfetchServiceRequest(),
    watchUpdateServiceRequest(),
    watchChangePassword(),
    watchfetchDashboard(),
    watchAddReservation(),
    watchFetchReservation(),
    watchUpdateReservation(),
    watchOrderHistoryDataByTableOtp(),
    watchFetchLiveOrderByTableOtp(),
    watchFetchTax(),
    watchUpdateTax(),
    watchFetchMenu(),
    watchUpdateMenuItemStatus(),
    watchGenerateLoginOTP(),
    watchLoginSubmit(),
    watchLogoutSubmit(),
    watchLoginOTPSubmit(),
    watchAddUser(),
    watchDeleteUser(),
    watchUpdateUser(),
    watchFetchUsersSaga(),
    watchResetPassword(),
    watchFetchCategoriesSaga(),
    watchAddCategory(),
    watchUpdateCategory(),
    watchDeleteCategory(),
    watchAddMenuItem(),
    watchFetchFoodItemsSaga(),
    watchDeleteMenuItem(),
    watchUpdateMenuItem(),
    watchFetchLiveOrder(),
    watchUpdateOrderStatus(),
    watchOrderHistoryData(),
    watchCancelledOrder(),
    watchAddTableNumber(),
    watchFetchTables(),
    watchDeleteTable(),
    watchEditTable(),
    watchGetRestaurantDetail(),
    watchUpdateRestaurantProfile(),
    watchFetchTablesWitOtp(),
    watchUpdateTableStatus(),
    watchPlaceOrder(),
    watchFetchBill(),
    watchSaveBill(),
    watchFetchBills(),
    watchFetchBillItem()
  ])
}

export default userSaga;

// ===== Later use dispatch to use it like =====
// import { useDispatch } from 'react-redux';
// import { fetchMenuData } from './usersSlice';

// const dispatch = useDispatch();

// const handlefetchMenuData = () => {
//   dispatch(fetchMenuData());
// };
